const imageProcessingLibs = {
    rgb2lab: require('../lib/color-math').rgb2lab,
    lab2rgb: require('../lib/color-math').lab2rgb,
    deltaE: require('../lib/color-math').deltaE,
    pixelMatches: require('../lib/color-math').pixelMatches,
    pixelMatchesIn: require('../lib/color-math').pixelMatchesIn,
    developedColors: require('../config/landcover-classes').landcoverGroups.developed,
    forestsColors: require('../config/landcover-classes').landcoverGroups.forests,
    wetlandsColors: require('../config/landcover-classes').landcoverGroups.wetlands,
    agricultureColors: require('../config/landcover-classes').landcoverGroups.agriculture
}
module.exports = {
    ImageProcessingLibs: imageProcessingLibs,
    RasterOperations: {
        generalChange: (pixels, data) => {
            const R = 0, G = 1, B = 2, A = 3;
            let pixel1 = pixels[0];
            let pixel2 = pixels[1];
            if (pixel1[A] > 0 && pixel2[A] > 0 && !eval("pixelMatches")(pixel1, pixel2)) {
                return [255, 0, 0, 255];
            }
            else
                return [0, 0, 0, 0]
        },

        developedChange: (pixels, data) => {
            const R = 0, G = 1, B = 2, A = 3;
            const fromPixel = pixels[0];
            const toPixel = pixels[1];
            let isfromPixelDeveloped = fromPixel[A] > 0 && eval("pixelMatchesIn")(fromPixel, eval("developedColors")())
            let isToPixelDeveloped = toPixel[A] > 0 && eval("pixelMatchesIn")(toPixel, eval("developedColors")())
            //check for developed loss or gain
            if (isfromPixelDeveloped && !isToPixelDeveloped) return [255, 0, 0, 255];
            else if (!isfromPixelDeveloped && isToPixelDeveloped) return [0, 255, 0, 255];
            else return [0, 0, 0, 0];
        },

        forestsChange: (pixels, data) => {
            const R = 0, G = 1, B = 2, A = 3;
            const fromPixel = pixels[0];
            const toPixel = pixels[1];
            let isfromPixelForests = fromPixel[A] > 0 && eval("pixelMatchesIn")(fromPixel, eval("forestsColors")())
            let isToPixelForests = toPixel[A] > 0 && eval("pixelMatchesIn")(toPixel, eval("forestsColors")())
            //check for Forests loss or gain
            if (isfromPixelForests && !isToPixelForests) return [255, 0, 0, 255];
            else if (!isfromPixelForests && isToPixelForests) return [0, 255, 0, 255];
            else return [0, 0, 0, 0];
        },

        wetlandsChange: (pixels, data) => {
            const R = 0, G = 1, B = 2, A = 3;
            const fromPixel = pixels[0];
            const toPixel = pixels[1];
            let isfromPixelWetlands = fromPixel[A] > 0 && eval("pixelMatchesIn")(fromPixel, eval("wetlandsColors")())
            let isToPixelWetlands = toPixel[A] > 0 && eval("pixelMatchesIn")(toPixel, eval("wetlandsColors")())
            //check for Wetlands loss or gain
            if (isfromPixelWetlands && !isToPixelWetlands) return [255, 0, 0, 255];
            else if (!isfromPixelWetlands && isToPixelWetlands) return [0, 255, 0, 255];
            else return [0, 0, 0, 0];
        },
        agricultureChange: (pixels, data) => {
            const R = 0, G = 1, B = 2, A = 3;
            const fromPixel = pixels[0];
            const toPixel = pixels[1];
            let isfromPixelWetlands = fromPixel[A] > 0 && eval("pixelMatchesIn")(fromPixel, eval("agricultureColors")())
            let isToPixelWetlands = toPixel[A] > 0 && eval("pixelMatchesIn")(toPixel, eval("agricultureColors")())
            //check for Wetlands loss or gain
            if (isfromPixelWetlands && !isToPixelWetlands) return [255, 0, 0, 255];
            else if (!isfromPixelWetlands && isToPixelWetlands) return [0, 255, 0, 255];
            else return [0, 0, 0, 0];
        }
    }
}